var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.complete)?_c('span',{staticClass:"px-2 flex items-center"},[_c('SuccessIcon')],1):_c('span',{staticClass:"px-2 flex items-center"},[_c('EmptyIcon')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }